<template>
  <div class="preserve-ratio-container">
    <div class="preserve-ratio-box" :style="{ width: '100%', 'padding-bottom': width && height ? `${(height / width) * 100}%` : 'auto' }"></div>
    <div class="preserve-ratio-slot">
      <!-- @slot The content to preserve space for. --><slot
      ></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    /**
     * The ratio width to preserve.
     */
    width: {
      type: Number,
    },
    /**
     * The ratio height to preserve.
     */
    height: {
      type: Number,
    },
  },
};
</script>
<style lang="postcss">
.preserve-ratio-container {
  display: flex;
  overflow: hidden;
  max-width: 100%;
  position: relative;

  .preserve-ratio-box {
    flex: 0 0 0px;
  }

  .preserve-ratio-slot {
    flex: 1 0 0px;
  }
}
</style>
